import { useEffect, useMemo, useState } from "react";
import { useLazyQuery, useQuery } from "@apollo/client";
import DEFAULT_OPERATIONS from "./Cart.gql";
import { useDispatch, useSelector } from "react-redux";
import { saveMegaMenu } from "../../features/MegaMenu/MegaMenuSlice";
import { logGenerator } from "../../utility/logGenerator";
import { GET_RECENTLY_VIEWED_LIST } from "../RecentlyViewedPage/RecentyViewed.gql";
import { useLocation } from "react-router-dom";

export const useCartPage = (props = {}) => {
  const { getCartDetailsQuery } = DEFAULT_OPERATIONS;
  const dispatch = useDispatch();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const isCartId = params.get("cart_id");
  const { cartId } = useSelector((state) => state.cartSlice);

  const [isCartUpdating, setIsCartUpdating] = useState(false);
  const recentlyViewedData = useSelector((state) => state.recentlyViewed);

  const [fetchCartDetails, { called, data, loading }] = useLazyQuery(
    getCartDetailsQuery,
    {
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
    }
  );

  const {
    data: recentlyViewedList,
    loading: recentlyLoading,
    error,
  } = useQuery(GET_RECENTLY_VIEWED_LIST, {
    variables: {
      productSkus: recentlyViewedData?.map((item) => item.sku),
    },
    skip: !recentlyViewedData?.length,
  });

  const hasItems = !!(data && data.cart.total_quantity);
  const shouldShowLoadingIndicator = loading && !hasItems;

  const cartItems = useMemo(() => {
    return (data && data.cart.items) || [];
  }, [data]);

  useEffect(() => {
    if (cartId || isCartId) {
      const idToUse = cartId || isCartId;
      logGenerator(
        "info",
        `useCartPage getCartDetailsQuery cartId : ${idToUse}`
      );
      fetchCartDetails({ variables: { cartId: idToUse } });
    }

    setIsCartUpdating(loading);
  }, [fetchCartDetails, cartId, isCartId]);

  useEffect(() => {
    dispatch(saveMegaMenu(false));
  }, []);

  return {
    cartItems,
    hasItems,
    isCartUpdating,
    fetchCartDetails,
    setIsCartUpdating,
    loading,
    recentlyViewedList,
    shouldShowLoadingIndicator,
  };
};
